export default "__VITE_ASSET__DKBna3LZ__"